import React, { useEffect, useMemo, useState } from 'react'
import { CloseButtonModal } from '../../../../common/modals/user-table-info/modal-sectors/CloseButtonModal'
import '../../../Formations/CreateFormations/createForm.css'
import { useAppSubmitForm } from '../../../Formations/CreateFormations/CreateFormationsControler'
import { GenericInput } from '../../../../common/GenericInput/GenericInput'
import { GenericSelect } from '../../../../common/GenericSelect/GenericSelect'
import { GenericCreatableSelect } from '../../../../common/GenericSelect/GenericCreatableSelect'
import { useSelector } from 'react-redux'
import logger from '../../../../../utils/logger'
import { formatDataforGenericSelect } from '../../../../../helper/formatDataforGenericSelect'
import { Link } from 'react-router-dom'
import { maxGeneratorDuration } from 'framer-motion'
import { useEditSubmitForm } from './editFormationController'
import { Controller } from 'react-hook-form'
import { GenericSelect2 } from '../../../../common/GenericSelect/GenericSelect2'
import { GenericCreatableSelect2 } from '../../../../common/GenericSelect/GenericCreatableSelect2'
import { MemberService } from '../../../../../services/MemberService'
import { FormationService } from '../../../../../services/formationService'
import { toast } from 'react-toastify'
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';




export const EditFormation = ({ closeBootstrapModal, formationId, formData, refetch, activeMembersLength, loading }) => {


  const [consent, setConsent] = useState(false)

  const professorsDataFormat = (data, slice) => {

    const newArray = data.slice(0, slice).map((p) => ({
      value: p.id,
      label: p.name,
    }))

    return newArray
  };

  const professorsPreValue = professorsDataFormat(formData.professors, 10)


  logger.debug('professorsFormatData: ', professorsPreValue)


  const [options, setOptions] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await FormationService.getProfessors({ professorName: `` }
        );

        // logger.debug('options response: ', response)

        if (response?.data?.length > 0) {
          const mapped = professorsDataFormat(response.data, 8)
          setOptions(mapped);
        }
      } catch (error) {
        logger.error("Error obteniendo sugerencias", error);
      }
    };

    fetchData();
  }, []);


  logger.debug('options: ', options)

  //? lista de formaciones 

  const selectListOptions = useSelector((data) => data.commonData.lista.formationPlaces)
  logger.debug('selectListOptions: ', selectListOptions)

  const formationPlaceOptions = useMemo(
    () => formatDataforGenericSelect(selectListOptions),
    [selectListOptions]
  );


  const [isFormationChange, setIsFormationChange] = useState(false)

  const ChangeFormationPlace = () => {
    setIsFormationChange(prev => !prev)
  };


  const { register, handleSubmit, onSubmit, setValue, message, errors, response, control, resetToInitialValues } = useEditSubmitForm(formData, refetch, closeBootstrapModal, formationPlaceOptions, professorsPreValue, activeMembersLength, ChangeFormationPlace, consent)



  const actionToast = (text, type) => {

    toast.success(text, {
      autoClose: 2000
    })

  }

  const errorToast = (text) => {
    toast.error(text, {
      autoClose: 2000
    })
  }




  useEffect(() => {
    // 👉 Validamos que 'response' tenga contenido real antes de hacer nada
    if (!response) return;

    logger.warn('response exitosa: ', response);

    try {
      if (response.status === 200 || response.status === 201) {
        // logger.warn('response exitosa: ', response);

        actionToast(response.data?.message);
        refetch();
        //👉 Solo cerramos si la operación fue exitosa
        closeBootstrapModal();
      } else {

        errorToast(message)
      }


    } catch (err) {
      logger.error('error de edicion', err);
      errorToast(err.message);
    }
  }, [response, refetch,])





  const [selectedValue, setSelectedValue] = useState(null);
  const handleSelectChange = (selectedOption) => {
    setSelectedValue(selectedOption)

  }

  const deleteAllUsers = () => {

    setConsent(true)
    ChangeFormationPlace()
  };

  const cancelDeleition = () => {
    setConsent(false)
  };

  //? 👉 captura el elemento "textArea" directamente cuando react-hook-form lo registra

  const { ref, ...rest } = register("description", {
    onChange: (e) => {
      const el = e.target;
      el.style.height = "auto";
      el.style.height = `${Math.max(el.scrollHeight, 56)}px`;
    }
  })

  return (





    <form
      id="miFormulario"
      className="form-createFormation"
      onSubmit={handleSubmit(onSubmit)}
      onKeyDown={(e) => {
        //👉 Si el usuario presiona Enter en cualquier input, select, react-select, creatable, etc → NO envía el formulario
        //👉 Enter en textarea sí funciona por los saltos de línea
        if (e.key === "Enter" && e.target.tagName !== "TEXTAREA") {
          e.preventDefault();
        }
      }}
    >
      <CloseButtonModal toggleModal={closeBootstrapModal} btnCloseClass={'btn-formation-close'} />


      <span className="formation-form-title">Editar Formación</span>

      <div className="form-floating mb-3">

        <GenericInput
          required={true}
          name={"name"}
          register={register}
          errors={errors}
          label="Nombre de la formación"
          validationMessage='El nombre es obligatorio'

        // placeholder="Matrícula Profesional"
        />

      </div>



      {/* <div className="form-floating mb-3">
        <textarea
          id="description"
          className="form-control auto-grow"
          placeholder=" "
          maxLength={200}
          {...register("description", {
            onChange: (e) => {
              const el = e.target;

              el.style.height = "auto";

              const minHeight = 56;
              const newHeight = Math.max(el.scrollHeight, minHeight);

              el.style.height = `${newHeight}px`;
            }
          })}
        />
        <label htmlFor="description">Descripción</label>
      </div> */}

      <div className="form-floating mb-3">
        <textarea
          {...rest}
          maxLength={200}
          ref={(e) => {
            ref(e); //? 👉 Asigna la referencia a react-hook-form
            if (e) {
              e.style.height = "56";
              e.style.height = `${Math.max(e.scrollHeight, 56)}px`;
            }
          }}
          id="description"
          className="form-control auto-grow"
        />
        <label htmlFor="description">Descripción</label>
      </div>


      <div className="form-floating mb-3">


        <Controller
          name="professors"
          control={control}
          rules={{ required: true }}
          render={({ field, fieldState }) => (
            <GenericCreatableSelect2
              value={field.value}           // valor inicial desde RHF
              onChange={field.onChange}     // sincroniza cambios con RHF
              onBlur={field.onBlur}
              options={options} // opciones que vienen de la API
              placeholder="Escriba para buscar o agregar profesores…"
              multi={true}
              // selectClass="form-control-height"
              showError={fieldState.invalid}
            />
          )}
        />

      </div>

      <div className="form-floating mb-3">

        <GenericInput
          required={true}
          name="date"
          register={register}
          errors={errors}
          label="Fecha"
          type='date'
          validationMessage='La fecha de formación es obligatoria'
        // placeholder="Matrícula Profesional"
        />
      </div>

      <div className="form-floating mb-3">


        <GenericInput
          required={false}
          name="maxQuota"
          register={register}
          errors={errors}
          label="Cupos"
          type='number'
          validationMessage='La fecha de formación es obligatoria'
        // placeholder="Matrícula Profesional"
        />

      </div>


      <div className="form-floating mb-3 ">



        <Controller
          name="formationPlaceId"
          control={control}
          rules={{ required: true }}
          render={({ field, fieldState }) => (
            <GenericSelect2
              value={field.value}
              onChange={field.onChange}
              onBlur={field.onBlur}
              options={formatDataforGenericSelect(selectListOptions)}
              placeholder="Seleccione un lugar de formación"
              closeMenu={true}
              showError={fieldState.invalid}
              isMulti={false}
            />
          )}
        />


      </div>

      {isFormationChange ?
        <div className="form-floating mb-3 ">

          <p>Al cambiar el lugar de la formación se eliminarán todos los miembros actualmente suscriptos. ¿Deseás continuar? </p>

          <div
            class="btns-cancel-renovation flex-row justify-content-center">

            <button
              className="btn-sr btn-sr-width btn btn-success"
              type="button"
              onClick={deleteAllUsers}
            >

              {/* {loadingDeleteUser ?
                <>
                  <Spinner
                    className='me-2'
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />

                  Eliminando..
                </>
                :
                <>
                  Si, Cambiar
                </>
              } */}

              Si, Cambiar
            </button>


            <button

              type="button"
              className="btn-cancel btn-sr-cancel"
              onClick={() => { resetToInitialValues(); ChangeFormationPlace() }}
            >
              Cancelar
            </button>

          </div>


        </div>

        :

        <div className="submit-button">
          <input type="submit" className="button-send" value="Guardar" />
          <small className="form-text text-muted small-cancelar">
            <Link
              to={`/FormationsDetail/${formationId}`}
              onClick={() => { closeBootstrapModal(); cancelDeleition() }}
            >Cancelar
            </Link>

          </small>

        </div>
      }



      {/* <div className="submit-button">
        <input type="submit" className="button-send" value="Guardar" />
        <small className="form-text text-muted small-cancelar">
          <Link
            to={`/FormationsDetail/${formationId}`}
            onClick={closeBootstrapModal}
          >Cancelar
          </Link>

        </small>

      </div> */}

    </form>

  )
}
